import { Checkbox, FormControlLabel, styled } from '@mui/material'
import React, { useState } from 'react'
import { CtrlParamsComponent } from '.'
import { ICtrl } from './models'
import { CtrlParamsPropsComponent } from './props'
import { CtrlParamsToolsComponent } from './tools'

const LeftContainerComponentStyled = styled(CtrlParamsToolsComponent)(({ theme }) => ({
  maxWidth: '33%',
}))

const MiddleContainerComponentStyled = styled(CtrlParamsComponent)(({ theme }) => ({
}))

const RightContainerComponentStyled = styled(CtrlParamsPropsComponent)(({ theme }) => ({
  maxWidth: '33%',
}))

export interface CtrlParamsEditorComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onChangeCtrols: (ctrls: ICtrl[]) => void,
  ctrls: ICtrl[]
}

export const CtrlParamsEditorComponent = (props: CtrlParamsEditorComponentProps) => {
  const [currCtrl, setCurrCtrl] = useState<ICtrl | undefined>()
  const [showValidateText, setShowValidateText] = useState<boolean | undefined>()

  const { onChangeCtrols: onChangeCtrls, ctrls, ...rest } = props

  return <div style={{ display: 'flex', flexDirection: 'column' }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={showValidateText}
          onChange={e => setShowValidateText(!showValidateText)} />
      }
      label='Exibir validação dos campos' />

    <div
      {...rest}
      className={`${props.className}${'containerComponent'}`}
      style={{ display: 'flex', ...props.style }}
    >
      <LeftContainerComponentStyled
        onClickItem={(ctrl: ICtrl) => {
          let ctrlsTmp = [...ctrls]
          if (currCtrl) {
            const idx = ctrlsTmp.indexOf(ctrlsTmp.filter(c => c.uuid == currCtrl.uuid)[0])
            if (idx >= 0)
              ctrlsTmp.splice(idx + 1, 0, ctrl)
          }
          else ctrlsTmp.push(ctrl)
          if (onChangeCtrls)
            onChangeCtrls(ctrlsTmp)
        }}
      />
      <MiddleContainerComponentStyled
        style={{ flexGrow: 1, borderLeft: '1px solid #C4C4C4' }}
        gap={20}
        ctrls={ctrls}
        onSelectItem={(ctrl) => {
          setCurrCtrl(ctrl)
        }}
        hover={true}
        showValidateText={showValidateText}
      />
      <RightContainerComponentStyled
        ctrl={currCtrl}
        style={{ borderLeft: '1px solid #C4C4C4', maxWidth: 400, minWidth: 200 }}
        onChangeCtrl={(ctrl) => {
          for (let i = 0; i < ctrls.length; i++) {
            const lCtrl = ctrls[i]
            if (lCtrl.uuid === ctrl.uuid) {
              ctrls[i] = ctrl
              break
            }
          }

          setCurrCtrl(ctrl)

          if (onChangeCtrls)
            onChangeCtrls(ctrls)
        }}
        onDelete={(ctrl: ICtrl) => {
          setCurrCtrl(undefined)
          let ctrlsTmp = [...ctrls.filter(c => c.uuid != ctrl.uuid)]
          if (onChangeCtrls)
            onChangeCtrls(ctrlsTmp)
        }}
      />
    </div>
  </div>
}